/* eslint-disable */
import $ from 'jquery';
import _ from 'underscore';
import * as dateFilterPref from '@bingads-webui-component-legacy/bingads-grid/service/date-filter-preferences';
import pageContext from '@bingads-webui-static-legacy/page-context';
import dateUtils from '@bingads-webui-static-legacy/utils/date';
import metadata from '@bingads-webui-static-legacy/date-range-metadata';
import Promise from 'bluebird';
var i18n = window.globalLegacyI18n.get('module/extension/requirejs/i18n!global');
function getFilterPromise(names) {
  return Promise.map(names, function (name) {
    return dateFilterPref.getDateFilterPreference(name).then(function () {
      var dateFilter = dateFilterPref.getDateFilter(name), today = dateUtils.date(dateUtils.accountTimeZoneNow()), range = dateFilter && dateFilter.dateFilters && dateFilter.dateFilters.primaryRange ? getPSTTime(dateFilter.dateFilters.primaryRange) : getDefaultRange(today), result;
      if (!(!!range.start && !!range.end) || !(range.start <= range.end && range.end <= today)) {
        range = getDefaultRange(today);
      }
      var lcid = !_.isEmpty(range) ? range.Rangelcid : 0;
      if (lcid > 0 && pageContext && pageContext.CurrentUser && lcid != pageContext.CurrentUser.Locale) {
        result = _.extend(getDefaultRange(today), {
          grain: 4
        });
      } else if (!!range.grain && !range.isCustom) {
        result = metadata.getRangeByGrainId(i18n, range.grain, null, null, today);
      } else if (!range.grain || !range.start || !range.end) {
        result = _.extend(getDefaultRange(today), {
          grain: 4
        });
      } else {
        result = range;
      }
      return {
        name: name,
        value: _.extend(result, {
          formattedStart: dateUtils.format(result.start),
          formattedEnd: dateUtils.format(result.end),
          formatedStart: dateUtils.format(result.start),
          formatedEnd: dateUtils.format(result.end),
          compared: range.comparedRange
        })
      };
    });
  });
}
function getDefaultRange(today) {
  return metadata.getRanges(i18n, null, null, today).thisMonth;
}
function getPSTTime(range) {
  range.start = new Date(range.start);
  range.end = new Date(range.end);
  return range;
}
export default {
  getFilterPromise: getFilterPromise
};

